import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
// import { makeStyles, styled } from '@mui/material/styles';
import { makeStyles, styled } from '@mui/styles';
import Container from '@mui/material/Container';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import CreditCardOffIcon from '@mui/icons-material/CreditCardOff';
import CodeOffIcon from '@mui/icons-material/CodeOff';
import CodeIcon from '@mui/icons-material/Code';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import BarChartIcon from '@mui/icons-material/BarChart';
import GroupsIcon from '@mui/icons-material/Groups';
import ScienceIcon from '@mui/icons-material/Science';
import JoinFullIcon from '@mui/icons-material/JoinFull';
import SpeedIcon from '@mui/icons-material/Speed';
import BuildIcon from '@mui/icons-material/Build';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Hidden from '@mui/material/Hidden';

import Base13Icon from './../../Color graphic - no background.png';
import Base13Logo from './../../Color logo - no background.png';
import Base13BlackLogo from './../../Black logo - no background.png';
import FloSQLLogo from './../../FloSQL Black logo - no background.png';
import OverlayFlowEditor from './../../overlayFlowEditor.png';
import OverlayFlowEditorLogo from './../../overlayFlowEditorLogo.png';
import BrainGraph from './../../BrainGraph.png';
import DBConnectionsLogos from './../../DBConnectionsLogos.png';
import FloSQLIntegrationsGraphic from './../../floSQLIntegrationsGraphic.png';
import SnowflakeLogo from './../../Snowflake_logo.png';
import RedashLogo from './../../redash_logo1.png';
import FacebookLogo from './../../facebookLogo.png';
import GoogleAdsLogo from './../../googleAdsLogo.png';
import GoogleAnalyticsLogo from './../../googleAnalyticsLogo.png';
import ShopifyLogo from './../../shopifyLogo.png';
import KlaviyoLogo from './../../klaviyoLogo.png';
import IngestionLogos from './../../ingestionLogos.png';
import CircleOne from './../../circleOne.png';
import CircleTwo from './../../circleTwo.png';
import CircleThree from './../../circleThree.png';
import CircleFour from './../../circleFour.png';
import RedashCharts from './../../redashCharts.png';
import FloSQLIcon from './../../Color just logo - no background.png';

import StreamLocatorLogo from './../../StreamLocator_logo.png';
import SMSLiveLogo from './../../smsliveLogo.png';
import StreamLocatorLogoGrey from './../../StreamLocator_logoGrey.png';
import SMSLiveLogoGrey from './../../smsliveLogoGrey.png';
import PBPLogoGrey from './../../pbp_logo_200Grey.png';
import EmergeLogoGrey from './../../emergeLogoGrey.png';
import ConnectionsLogos from './../../ConnectionsLogos.png';

import Header from './Header';
import Footer from './Footer';

const useStyles = makeStyles(({ theme }) =>  ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
      autoWidth: 'false',
    },
  },
  logoPadding: {
    flex: 1,
    padding: 2,
    maxWidth: 20,
    resizeMode: 'contain'
  },
  button: {
    margin: theme.spacing(1),
  },
  snowflakeLogo: {
    width: '75vw',
    maxWidth: 50,
    // height: 256,
  },
  facebookLogo: {
    width: '75vw',
    maxWidth: 50,
    // height: 256,
  },
  googleAdsLogo: {
    width: '75vw',
    maxWidth: 50,
    // height: 256,
  },
  googleAnalyticsLogo: {
    width: '75vw',
    maxWidth: 50,
    // height: 256,
  },
  shopifyLogo: {
    width: '75vw',
    maxWidth: 50,
    // height: 256,
  },
  klaviyoLogo: {
    width: '75vw',
    maxWidth: 50,
    // height: 256,
  },
  streamLocatorLogo: {
    width: '75vw',
    maxWidth: 200,
    paddingTop: 20,
    // marginRight: 100,
    // height: 312,
  },
  smsLiveLogo: {
    width: '75vw',
    maxWidth: 175,
    paddingTop: 10,
    // marginRight: 100,
    // height: 312,
  },
  cardCaseStudy: {
    // maxWidth: 972,
    transition: "0.3s",
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
    "&:hover": {
      boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
    }
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
  dwdblogoPadding: {
    flex: 1,
    padding: 2,
    maxWidth: 10,
    resizeMode: 'contain'
  },
  overlayFlowEditor: {
    width: '75vw',
    maxWidth: 172,
  },
  overlayFlowEditorTwo: {
    flex: 1,
    padding: 2,
    width: '75vw',
    maxWidth: 1032,
    // height: 400,
    resizeMode: 'contain'
  },
  loginButton: {
    color:"#cbd5e1",
    borderColor:"#cbd5e1",
  '&:hover': {
      borderColor: '#0284c7',
    }
    },
  button: {
    margin: theme.spacing(1),
  },
  root: {
    margin: 'auto',
    borderRadius: theme.spacing(2), // 16px
    transition: '0.3s',
    boxShadow: '0px 14px 80px rgba(34, 35, 58, 0.2)',
    position: 'relative',
    maxWidth: 500,
    marginLeft: 'auto',
    overflow: 'initial',
    background: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: theme.spacing(2),
    [theme.up('md')]: {
      flexDirection: 'row',
      paddingTop: theme.spacing(2),
    },
  },

}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#F1F6F9' : '#F1F6F9',
  ...theme.typography.h4,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));



export default function HomePage() {
  const classes = makeStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <Header/>

      <Container maxWidth="lg" component="main" className={classes.heroContent} style={{color:"#37474f"}} >

        <Box style={{padding:50}}></Box>
        <Grid container direction={'row'} alignItems="flex" >
        <Grid
            item
            container
            direction="column"
            alignItems="flex-start"
            justify="center" xs={12} sm={12} md={6} lg={6} >
        <Hidden smDown><Box style={{padding:50}}></Box></Hidden>
        <Typography component="h1" variant="h3" style={{ fontWeight: 'bold', fontStyle: 'bolded', fontFamily: 'Arial'}} align="left" justify="center" color="textPrimary" >
          Take control of your data
        </Typography>
        <Box style={{padding:20}}></Box>
        <Typography component="h1" variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial'}} align="left" justify="center" color="textSecondary" >
          The fastest and most effective way to solve your unique business requirements.
        </Typography>
        <Box style={{padding:10}}></Box>
        <Hidden smDown>
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <AllInclusiveIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5}} align="center" color="textSecondary" component="h4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >Scalable</Box>
        </Typography>
        <BuildIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="center" color="textSecondary" component="p4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Customizable</Box>
        </Typography>
        <SpeedIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="center" color="textSecondary" component="h4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Hyper Fast</Box>
        </Typography>
        </Box>
        <Box style={{padding:10}}></Box>
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <JoinFullIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="center" color="textSecondary" component="p4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Join Sources</Box>
        </Typography>
        <ScienceIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="center" color="textSecondary" component="p4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Advanced Capabilities</Box>
        </Typography>
        </Box>
        </Hidden>
        <Box style={{padding:20}}></Box>

          <Box className={classes.button} >
            <Button size="large" href='/LearnMore' variant="outlined" style={{color: "white", backgroundColor:"#0284c7", borderColor:"#0284c7", fontSize: '20px', maxWidth: '250px', maxHeight: '50px', minWidth: '100px', minHeight: '20px', textTransform: 'none'}} >Learn More</Button>
          </Box>

        </Grid>
        <Box style={{paddingRight:50}}></Box>
        <Grid item
            container
            alignItems="flex"
            justify="center"
            xs={0} sm={0} md={4} lg={4}
            paddingRight={25}>
        <Hidden smDown>
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"

        // style={{padding:0, maxWidth:50, paddingTop:50}}
        >
          <img style={{padding:0, maxWidth:600}} className={classes.overlayFlowEditorTwo} src={ConnectionsLogos}/>
        </Box>
        </Hidden>
        </Grid>

            <Box style={{paddingRight:100}}></Box>

        </Grid>

        <Grid container alignItems="flex-end" >
        <Grid xs={12} sm={12} md={1} lg={1} ></Grid>
        <Grid xs={12} sm={12} md={10} lg={10} >



          </Grid>

          </Grid>

        <Box style={{padding:50}}></Box>

        <Grid container alignItems="flex-end" >
        <Grid xs={12} sm={12} md={12} lg={12} alignItems="flex-end">
        <Typography component="h5" variant="h5" style={{ fontStyle: 'bolded', fontFamily: 'Arial'}} align="center" justify="center" color="textSecondary" >
          Businesses with an effective data strategy use Base13 Labs
        </Typography>

        <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={{ xs: 1, sm: 2, md: 4 }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
          <img className={classes.streamLocatorLogo} style={{ maxWidth: 150 }} src={StreamLocatorLogoGrey}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.smsLiveLogo} style={{ maxWidth: 175 }} src={PBPLogoGrey}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={EmergeLogoGrey}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={SMSLiveLogoGrey}/>

        </Stack>
        </Grid>
        </Grid>



        <Box style={{padding:50}}></Box>

        <Card className={classes.root} style={{backgroundColor: "#F1F6F9", borderRadius: 16}}>

        <Grid container alignItems="flex-end" >
        {/*<Grid xs={12} sm={12} md={2} lg={2} >*/}
        {/*<Box style={{padding: 20}} align="center">
          <CardMedia
            component="img"
              src={CircleOne}
              style={{ maxWidth: 100 }}
          />
          </Box>
          <Box style={{padding:10}}></Box>*/}
        {/*</Grid>*/}

        <Grid xs={12} sm={12} md={6} lg={6} >
            <CardContent style={{backgroundColor: "#F1F6F9"}} >
             <Box style={{padding:50}} align="center" >
              <Typography component="div" variant="h4" align="left" >
              <Hidden smDown>
              <Box sx={{ fontWeight: 'bold', paddingLeft:3, paddingRight:3 }} display='inline' >
              Consolidate your data
              </Box>
              </Hidden>
              <Hidden mdUp>
              <Box sx={{ fontWeight: 'bold' }} display='inline' >
              Consolidate your data
              </Box>
              </Hidden>
              </Typography>
              <Box style={{padding:20}}></Box>
              <Box
              display="flex"
              alignItems="left"
              justifyContent="left"
              style={{padding:0}}
              >
              <Box style={{paddingLeft:25}}></Box>
              <CheckCircleIcon style={{color:'#0284c7', width:35, height:35, paddingRight:5}} fontsize="small"/>
              <Typography component="div" variant="h6" align="left" color="textSecondary">
              <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >
              Leverage 100s of data sources
              </Box>
              </Typography>
              </Box>
              <Box style={{padding:5}}></Box>
              <Box
              display="flex"
              alignItems="left"
              justifyContent="left"
              style={{padding:0}}
              >
              <Box style={{paddingLeft:25}}></Box>
              <CheckCircleIcon style={{color:'#0284c7', width:35, height:35, paddingRight:5}} fontsize="small"/>
              <Typography component="div" variant="h6" align="left" color="textSecondary">
              <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >
              Infinitely scalable data warehouse
              </Box>
              </Typography>
              </Box>
              <Box style={{padding:5}}></Box>
              <Box
              display="flex"
              alignItems="left"
              justifyContent="left"
              style={{padding:0}}
              >
              <Box style={{paddingLeft:25}}></Box>
              <CheckCircleIcon style={{color:'#0284c7', width:35, height:35, paddingRight:5}} fontsize="small"/>
              <Typography component="div" variant="h6" align="left" color="textSecondary">
              <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >
              Cost efficient setup
              </Box>
              </Typography>
              </Box>
              <Box style={{padding:5}}></Box>
              <Box
              display="flex"
              alignItems="left"
              justifyContent="left"
              style={{padding:0}}
              >
              <Box style={{paddingLeft:25}}></Box>
              <CheckCircleIcon style={{color:'#0284c7', width:35, height:35, paddingRight:5}} fontsize="small"/>
              <Typography component="div" variant="h6" align="left" color="textSecondary">
              <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >
              Connect with your favorite ETL platform
              </Box>
              </Typography>
              </Box>
              </Box>
              {/*<Box style={{padding:10}}></Box>*/}
              <Box className={classes.button} style={{paddingLeft:70}}>
                <Button size="large" href='/LearnMore' variant="outlined" style={{color: "#0284c7", borderColor:"#0284c7", fontSize: '20px', maxWidth: '250px', maxHeight: '50px', minWidth: '100px', minHeight: '20px', textTransform: 'none'}} >Explore Options</Button>
              </Box>
              {/*<Box style={{padding:20}} align="center" >
              <Button   align="center" fullwidth size="large" href='https://www.flosql.com/?utm_source=referral&utm_medium=website&utm_campaign=base13learnmore' variant="contained" style={{color:"#0284c7", borderColor:"#0284c7"}} target="_blank" >
                Learn More
              </Button>
              </Box>*/}
              <Box style={{padding:5}}></Box>
            </CardContent>
        </Grid>

        <Grid xs={12} sm={12} md={6} lg={6}>
          {/*<Box style={{paddingRight:20}} align="center">
          <CardMedia
            component="img"
              src={SnowflakeLogo}
              width='50'
              style={{ maxWidth: 300 }}
          />
          </Box>*/}
          <Hidden smDown>
          <Box style={{paddingLeft: 0, paddingRight: 100, paddingTop: 0, paddingBottom: 100, display: 'flex', alignItems: 'center', justifyContent:'center'}} >
          <CardMedia
            component="img"
            src={DBConnectionsLogos}
            style={{ maxWidth: 1200}}
          />
          </Box>
          </Hidden>
          <Box style={{padding:0}}></Box>
        </Grid>

        </Grid>

        </Card>


        <Box style={{padding:50}}></Box>

        <Card className={classes.root} style={{backgroundColor: "#F1F6F9", borderRadius: 16}}>

        <Grid container alignItems="flex-end" >
        <Grid xs={12} sm={12} md={6} lg={6} >
            <CardContent style={{backgroundColor: "#F1F6F9"}} >
             <Box style={{padding:50}} align="center" >
             <Typography component="div" variant="h4" align="left" >
              <Hidden smDown>
              <Box sx={{ fontWeight: 'bold', paddingLeft:3, paddingRight:3 }} display='inline' >
              Customizable KPIs
              </Box>
              </Hidden>
              <Hidden mdUp>
              <Box sx={{ fontWeight: 'bold' }} display='inline' >
              Customizable KPIs
              </Box>
              </Hidden>
              </Typography>


              <Box style={{padding:20}}></Box>
              <Box
              display="flex"
              alignItems="left"
              justifyContent="left"
              style={{padding:0}}
              >
              <Box style={{paddingLeft:25}}></Box>
              <CheckCircleIcon style={{color:'#0284c7', width:35, height:35, paddingRight:5}} fontsize="small"/>
              <Typography component="div" variant="h6" align="left" color="textSecondary">
              <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >
              Templates automatically populate your dashboards
              </Box>
              </Typography>
              </Box>
              <Box style={{padding:5}}></Box>
              <Box
              display="flex"
              alignItems="left"
              justifyContent="left"
              style={{padding:0}}
              >
              <Box style={{paddingLeft:25}}></Box>
              <CheckCircleIcon style={{color:'#0284c7', width:35, height:35, paddingRight:5}} fontsize="small"/>
              <Typography component="div" variant="h6" align="left" color="textSecondary">
              <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >
              Customizable CAC, LTV, ROAS and more
              </Box>
              </Typography>
              </Box>
              <Box style={{padding:5}}></Box>
              <Box
              display="flex"
              alignItems="left"
              justifyContent="left"
              style={{padding:0}}
              >
              <Box style={{paddingLeft:25}}></Box>
              <CheckCircleIcon style={{color:'#0284c7', width:35, height:35, paddingRight:5}} fontsize="small"/>
              <Typography component="div" variant="h6" align="left" color="textSecondary">
              <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >
              Leverage predictive models
              </Box>
              </Typography>
              </Box>
              <Box style={{padding:5}}></Box>
              <Box
              display="flex"
              alignItems="left"
              justifyContent="left"
              style={{padding:0}}
              >
              <Box style={{paddingLeft:25}}></Box>
              <CheckCircleIcon style={{color:'#0284c7', width:35, height:35, paddingRight:5}} fontsize="small"/>
              <Typography component="div" variant="h6" align="left" color="textSecondary">
              <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >
              Ready your data stack for machine learning
              </Box>
              </Typography>
              </Box>
              </Box>
              {/*<Box style={{padding:10}}></Box>*/}
              <Box className={classes.button} style={{paddingLeft:70}}>
                <Button size="large" href='/LearnMore' variant="outlined" style={{color: "#0284c7", borderColor:"#0284c7", fontSize: '20px', maxWidth: '350px', maxHeight: '75px', minWidth: '100px', minHeight: '20px', textTransform: 'none', textTransform: 'none'}} >Talk to an Expert</Button>
              </Box>
              {/*<Box style={{padding:20}} align="center" >
              <Button   align="center" fullwidth size="large" href='https://www.flosql.com/?utm_source=referral&utm_medium=website&utm_campaign=base13learnmore' variant="contained" style={{color:"#0284c7", borderColor:"#0284c7"}} target="_blank" >
                Learn More
              </Button>
              </Box>*/}
              <Box style={{padding:5}}></Box>
            </CardContent>
        </Grid>

        <Grid xs={12} sm={12} md={6} lg={6} >
          <Hidden smDown>
          <Box style={{paddingLeft: 0, paddingRight: 20, paddingTop: 0, paddingBottom: 20, display: 'flex', alignItems: 'center', justifyContent:'center'}} >
          <CardMedia
              component="img"
              src={BrainGraph}
              style={{ maxWidth: 400 }}
              />
        </Box>
        </Hidden>
        <Box style={{paddingBottom:40}}></Box>
        </Grid>

        </Grid>
        </Card>

        <Box style={{paddingBottom:100}}></Box>

        <Card className={classes.root} style={{backgroundColor: "#F1F6F9", borderRadius: 16}}>

        <Grid container alignItems="flex-end" >

        <Grid xs={12} sm={12} md={7} lg={7} >
            <CardContent style={{backgroundColor: "#F1F6F9"}} >
             <Box style={{padding:50}} align="center" >
              <Typography component="div" variant="h4" align="left" >
              <Box sx={{ fontWeight: 'bold', paddingLeft:3, paddingRight:3 }} display='inline' >
              Future proof your data
              </Box>
              </Typography>
              <Box style={{padding:20}}></Box>
              <Box
              display="flex"
              alignItems="left"
              justifyContent="left"
              style={{padding:0}}
              >
              <Box style={{paddingLeft:25}}></Box>
              <CheckCircleIcon style={{color:'#0284c7', width:35, height:35, paddingRight:5}} fontsize="small"/>
              <Typography component="div" variant="h6" align="left" color="textSecondary">
              <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >
              Prepare for a data team or excelerate your current one
              </Box>
              </Typography>
              </Box>
              <Box style={{padding:5}}></Box>
              <Box
              display="flex"
              alignItems="left"
              justifyContent="left"
              style={{padding:0}}
              >
              <Box style={{paddingLeft:25}}></Box>
              <CheckCircleIcon style={{color:'#0284c7', width:35, height:35, paddingRight:5}} fontsize="small"/>
              <Typography component="div" variant="h6" align="left" color="textSecondary">
              <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >
              SQL templates right out of the box
              </Box>
              </Typography>
              </Box>
              <Box style={{padding:5}}></Box>
              <Box
              display="flex"
              alignItems="left"
              justifyContent="left"
              style={{padding:0}}
              >
              <Box style={{paddingLeft:25}}></Box>
              <CheckCircleIcon style={{color:'#0284c7', width:35, height:35, paddingRight:5}} fontsize="small"/>
              <Typography component="div" variant="h6" align="left" color="textSecondary">
              <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >
              Data model scheduling and dependency management
              </Box>
              </Typography>
              </Box>
              <Box style={{padding:5}}></Box>
              <Box
              display="flex"
              alignItems="left"
              justifyContent="left"
              style={{padding:0}}
              >
              <Box style={{paddingLeft:25}}></Box>
              <CheckCircleIcon style={{color:'#0284c7', width:35, height:35, paddingRight:5}} fontsize="small"/>
              <Typography component="div" variant="h6" align="left" color="textSecondary">
              <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >
              Identify data accuracy issues
              </Box>
              </Typography>
              </Box>
              </Box>
              {/*<Box style={{padding:10}}></Box>*/}
              <Box className={classes.button} style={{paddingLeft:70}}>
                <Button size="large" href='https://www.flosql.com/?utm_source=referral&utm_medium=website&utm_campaign=base13header' variant="outlined" style={{color: "#0284c7", borderColor:"#0284c7", fontSize: '20px', maxWidth: '350px', maxHeight: '75px', minWidth: '100px', minHeight: '20px', textTransform: 'none', textTransform: 'none'}} startIcon={<img src={FloSQLIcon} style={{ maxWidth:25 }} />} target="_blank">Learn more about FloSQL</Button>
              </Box>
              {/*<Box style={{padding:20}} align="center" >
              <Button   align="center" fullwidth size="large" href='https://www.flosql.com/?utm_source=referral&utm_medium=website&utm_campaign=base13learnmore' variant="contained" style={{color:"#0284c7", borderColor:"#0284c7"}} target="_blank" >
                Learn More
              </Button>
              </Box>*/}
              <Box style={{padding:5}}></Box>
            </CardContent>
        </Grid>

        <Grid xs={12} sm={12} md={5} lg={5} direction="column" justify="center" alignItems="center">
        {/*<Box style={{paddingLeft: 0, paddingRight: 20, paddingTop: 0, paddingBottom: 0, display: 'flex',
     alignItems: 'center',
     justifyContent:'center'}} >
          <CardMedia
              component="img"
              src={FloSQLLogo}
              style={{ maxWidth: 500}}
              />
              </Box>*/}
        <Box style={{paddingLeft: 0, paddingRight: 50, paddingTop: 0, paddingBottom: 50, display: 'flex', alignItems: 'center', justifyContent:'center'}} >
          <Hidden smDown>
          <CardMedia
            component="img"
              src={OverlayFlowEditorLogo}
              style={{ maxWidth: 500 }}
          />
          </Hidden>
          </Box>
          <Box style={{paddingBottom:10}}></Box>

        </Grid>

        </Grid>
        </Card>

        <Box style={{padding:50}}></Box>



        <Grid container spacing={5} alignItems="flex-end">

        <Grid item xs={12} sm={12} md={6} lg={6}>
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
        <Card className={classes.cardCaseStudy} elevation={2} >
            <Box style={{padding:10}} >
            <CardContent >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
                  <CardMedia
                    component="img"
                    src={SMSLiveLogo}
                    style={{ maxWidth: 175 }}
                  />
              </Box>

              <Typography variant="h5" color="textSecondary" component="p" style={{paddingLeft:20, paddingTop:40, paddingRight:20}}>
                "We reached our data strategy goals with FloSQL in days saving us time and money in development costs."
              </Typography>
              <Typography variant="h5" color="textSecondary" component="p" align="right" style={{paddingRight:50, paddingTop:20}}>
                James Corr
              </Typography>
              <Typography variant="h5" color="textSecondary" component="p" align="right" style={{paddingRight:50, paddingTop:0}}>
                Founder
              </Typography>

            </CardContent>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="center" style={{padding:10}}>
            <CardActions >
              <Button size="large" href='/SMSLiveCaseStudy' variant="outlined" style={{color: "#0284c7", textTransform: 'none'}} >
                Case Study
              </Button>
            </CardActions>
            </Box>

        </Card>
        </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6}>
        <Box
        display="flex"
        style={{padding:20}}
        >
        <Card className={classes.cardCaseStudy} >
            <Box style={{padding:10}}>
            <CardContent>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
                  <CardMedia
                    component="img"
                    src={StreamLocatorLogo}
                    style={{ maxWidth: 225 }}
                  />
              </Box>
              <Typography variant="h5" color="textSecondary" component="p" style={{paddingLeft:20, paddingTop:40, paddingRight:20}}>
                "FloSQL made it easy for us to combine all of our sources of data so we could build
                insights to drive sales."
              </Typography>
              <Typography variant="h5" color="textSecondary" component="p" align="right" style={{paddingRight:50, paddingTop:20}}>
                Jason Salzman
              </Typography>
              <Typography variant="h5" color="textSecondary" component="p" align="right" style={{paddingRight:50, paddingTop:0}}>
                COO
              </Typography>
            </CardContent>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="center" style={{padding:10}}>
            <CardActions >
              <Button  fullwidth size="large" href='/StreamLocatorCaseStudy' variant="outlined" style={{color: "#0284c7", textTransform: 'none'}} >
                Case Study
              </Button>
            </CardActions>
            </Box>
        </Card>
        </Box>
        </Grid>
        </Grid>

        <Grid container alignItems="flex-end" >
        <Grid xs={12} sm={12} md={1} lg={1} ></Grid>
        <Grid xs={12} sm={12} md={10} lg={10} >

        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{padding:40}}
          >
          <Box className={classes.button} >
            <Button size="large" href='/LearnMore' variant="outlined" style={{color: "white", backgroundColor:"#0284c7", borderColor:"#0284c7", fontSize: '20px', maxWidth: '250px', maxHeight: '50px', minWidth: '100px', minHeight: '20px', textTransform: 'none'}} >Learn More</Button>
          </Box>
          <Box style={{padding:10}}></Box>
          </Box>

          </Grid>

          </Grid>

      </Container>

      <Footer/>
    </React.Fragment>
  );
}